// src/components/Blocks/Banner/CustomBlockDataForm.jsx
import React from 'react';
import { BlockDataForm as OriginalBlockDataForm } from '@plone/volto/components';

const CustomBlockDataForm = (props) => {
  const { schema, errors, onChangeBlock, ...rest } = props;

  // Normalizza gli errori per ogni campo nello schema
  const normalizeFieldErrors = (fieldErrors) => {
    if (!fieldErrors) return [];
    return Array.isArray(fieldErrors) ? fieldErrors : [fieldErrors?.message || String(fieldErrors)];
  };

  // Aggiorna lo schema con errori normalizzati
  const normalizedSchema = {
    ...schema,
    properties: Object.fromEntries(
      Object.entries(schema.properties).map(([key, field]) => [
        key,
        { ...field, error: normalizeFieldErrors(errors?.[key]) },
      ])
    ),
  };

  return (
    <OriginalBlockDataForm
      {...rest}
      schema={normalizedSchema}
      errors={errors}
      onChangeBlock={onChangeBlock} // Passiamo onChangeBlock
    />
  );
};

export default CustomBlockDataForm;